<template>
  <v-container fluid>
    <v-row :align="contentAlign" :justify="contentJustify">
      <v-col cols="12" md="6" class="pa-0 auth-bg-container">
        <div class="auth-bg">
          <img
            :src="logoImage"
            alt="Bee Logo"
            class="auth-bg-logo"
          />
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <slot/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import beeLogoColor from '@/assets/img/bee-logo-color.png';

export default {
  name: 'AuthLayout',
  props: {
    contentAlign: { type: String, default: 'center' },
    contentJustify: { type: String, default: 'center' },
  },
  computed: {
    logoImage() {
      return beeLogoColor;
    },
  },
};
</script>

<style scoped>
.auth-bg-container {
  height: 100vh;
}

.auth-bg {
  background-color: #3d3b6e;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.auth-bg-logo {
  width: 110%;
  max-width: 700px;
  height: auto;
  opacity: 0.25;
  filter: grayscale(100%) brightness(1.8);
  transform: rotate(-15deg) translateX(-5%);
}
</style>
